import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  HOME_HASH_SECTION_IDS,
  scheduleScrollToHomeSection,
} from '../lib/homeSectionNavigation';

/** When the homepage loads with a hash (footer link, shared URL), jump to that section. */
export function useHomeHashScroll() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;

    const sectionId = decodeURIComponent((location.hash || '').replace(/^#/, '').trim());
    if (!sectionId || !HOME_HASH_SECTION_IDS.has(sectionId)) return;

    scheduleScrollToHomeSection(sectionId, { behavior: 'auto' });
  }, [location.pathname, location.hash, location.key]);
}
